import { MonitoringAccessRequest, MonitoringAccessResponse } from 'types';

import { api } from './api';

export const sundialApi = api.injectEndpoints({
  endpoints: (build) => ({
    checkMonitoringAccess: build.mutation<MonitoringAccessResponse, { accountId: string } & MonitoringAccessRequest>(
      {
        query: ({ accountId, monitoringIds }) => ({
          url: `v3/accounts/${accountId}/sundial/check-monitoring-access`,
          method: 'POST',
          body: { monitoringIds },
        }),
      },
    ),
  }),
});

export const { useCheckMonitoringAccessMutation } = sundialApi;
